import { injectIntl } from 'react-intl';
import React, { useState, useContext, useRef, useEffect } from 'react';
import { Dropdown, Menu, Skeleton, Divider } from 'antd';
import myContext from '@/utils/createContext';

import { gtag, NumFormat } from '@/utils/index';

const ProductsZD = (props) => {
	const { intl } = props;
	const { formatMessage } = intl;
	const { isMobileView, showDomain, cashierData } = useContext(myContext);

	// 增加骨架屏设置
	const [isShowProducts, setIsShowProducts] = useState(isMobileView ? false :true);

	const iconRef = useRef(null);

	const {
		actualPaymentCurrency,
		totalCurrencySymbol,
		orderServiceChargeAmount,
		orderServiceChargeRate,
		totalAmount,
		products,

	} = cashierData || '';

	console.log(products);

	/****** 初始化移动端按钮方向向下 ******/
	useEffect(() => {
		isMobileView ? iconRef.current.style.transform = 'rotate(0deg)' : '';
		isMobileView ? setIsShowProducts(false) : setIsShowProducts(true);

	}, []);


	/******* 控制按钮方向及打开Products ******/
	const showProducts = () => {
		gtag(`${showDomain}支付页面`, [new Date() + '用户查看产品次数'])
		gtag(`${showDomain}支付页面`, ['用户查看产品次数'])
		
		setIsShowProducts(!isShowProducts);

		isShowProducts ? iconRef.current.style.transform = 'rotate(0deg)' : iconRef.current.style.transform = 'rotate(180deg)';
	}


	const lists = () => {
		const paymentAmount = NumFormat(parseFloat(totalAmount) - parseFloat(orderServiceChargeAmount ? orderServiceChargeAmount : '0.00'));

		return (
			<div className="product-lists">
				{
					<>
						<Menu className="product-lists-bottom">
							<Menu.Item key="subTotal" className="product-lists-bottom-item product-lists-bottom-subtotal">

								<div className="product-lists-bottom-item-title">
									{
										products ?
											<span>{products}</span>
											:
											formatMessage({ id: "ga-checkout.product-info.tuition-fee" })
									}
									
								</div>
								<div className="product-lists-bottom-item-price">{totalCurrencySymbol} {paymentAmount ? paymentAmount : '0.00'} {actualPaymentCurrency}</div>
							</Menu.Item>
							{
								orderServiceChargeRate ?
									<Menu.Item key="other-fee" className="product-lists-bottom-item  product-lists-bottom-other">
										<div className="product-lists-bottom-item-title">{formatMessage({ id: "ga-checkout.product-info.Payment-process-fee-title" })} ({orderServiceChargeRate}%)</div>


										<div className="product-lists-bottom-item-price">{totalCurrencySymbol} {orderServiceChargeAmount ? orderServiceChargeAmount : '0.00'} {actualPaymentCurrency}</div>
									</Menu.Item>
									:
									''
							}

							{ isMobileView ? "" : <Divider></Divider> }
							<Menu.Item key="Total" className="product-lists-bottom-item product-lists-bottom-total">
								<div className="product-lists-bottom-item-title">{formatMessage({id: "ga-checkout.product-info.total"})}</div>
								<div className="product-lists-bottom-item-price product-lists-bottom-total-price">{totalCurrencySymbol} {totalAmount} {actualPaymentCurrency}</div>
							</Menu.Item>
						</Menu>
					</>
				}
			</div>
		)
	}

	return (
		<div className="vh5pc-cashier-container-right-content h5pc-order-info h5pc-zd-order-info" id="productsOrder" style={{ position: 'relative' }}>

			<div className="h5pc-order-info-detail">
				<div className="order-summary">
					<div className="images">
						{/* <img src="/static/images/h5/cart.png" alt="icon" className="icon" /> */}
						<span className='order-summary-cart-icon'></span>
					</div>
					<div className="order-summary-tile">{formatMessage({ id: 'ga-checkout.order-summary' })}</div>
				</div>
			</div>
			<Dropdown overlay={lists} visible={isShowProducts} getPopupContainer={() => document.getElementById('productsOrder')}>

				<a className="ant-dropdown-link vh5pc-cashier-container-right-content-order-top" onClick={() => { showProducts() }}>
					{totalCurrencySymbol} {totalAmount} {actualPaymentCurrency} 
					<span className='show-product-lists-icon' ref={iconRef} ></span>
				</a>

			</Dropdown>
		</div>
	)
}

export default injectIntl(ProductsZD);